import {
	Column,
	Item
} from 'devextreme-react/data-grid';

import { Link, useNavigate } from 'react-router-dom';
import { LoadPagePanel, SyncDataGrid } from '../../../../components';
import { useGetCompanyUsers } from '../../../../api/users';
import { useAuth } from '../../../../contexts/auth';
import Button from 'devextreme-react/button';

export default function UserGrid() {

	const { user } = useAuth();
	const users = useGetCompanyUsers(user?.companyId!);
	const navigate = useNavigate();

	return (
		<>
			<SyncDataGrid
				stateStorageKey='user-grid'
				className={'dx-card wide-card'}
				dataSource={users.data}
				keyExpr={['userName']}
				additionalToolbarItems={[
					<Item location='after' key='new-user'>
						<Button
							text="Add New User"
							icon="Inscyth-Add"
							onClick={() => {
								navigate('/cfi/users/new')
							}} >
						</Button>
					</Item>
				]}
			>
				<Column
					dataField={'fullName'}
					caption={'Name'}
					dataType="string"
					cellRender={(cell: any) => {
						return <Link to={`/cfi/users/user/${encodeURIComponent(cell.data.userName)}`}>
							{cell.data.fullName}
						</Link>;
					}}
				/>
				<Column
					dataField={'userName'}
					caption={'User Name'}
					dataType="string"
				/>
				<Column
					dataField={'emailAddress'}
					caption={'Email Address'}
					dataType="string"
				/>
				<Column
					dataField={'phone'}
					caption={'Phone'}
					dataType="string"
				/>
				<Column
					dataField={'phoneExtension'}
					caption={'Phone Extension'}
					dataType="string"
				/>
				<Column
					dataField={'groups'}
					caption={'User Roles'}
					dataType="string"
				/>
				<Column
					dataField={'inactive'}
					caption={'Inactive'}
					dataType="boolean"
				/>
			</SyncDataGrid>

			<LoadPagePanel visible={users.isLoading} />
		</>
	)
} 
